export const command = {
  openMenu: 'Menu',
  search: 'Wyszukaj',
  noResults: 'Brak rezultatów',
  actions: 'Akcje',
  manage: 'Zarządanie',
  simulation: 'Symulacja',
} as const
